import { createTheme } from '@mui/material/styles';
import { lighten } from '@mui/material';
const theme = createTheme({
  palette: {
    primary: { main: '#64AE37',contrastText: '#fff',  light: lighten('#64AE37', 0.9), },
    secondary: { main: '#173031' },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: lighten('#64AE37', 0.9), // tono claro del primario
          '&.Mui-focused': {
            backgroundColor: '#fff', // fondo blanco al enfocar
          },
          '& input:-webkit-autofill': {
            WebkitBoxShadow: `0 0 0px 1000px ${lighten('#64AE37', 0.9)} inset`, // color del background
            WebkitTextFillColor: '#64AE37', // color del texto
          },
          '& input:-moz-autofill': {
            boxShadow: `0 0 0px 1000px ${lighten('#64AE37', 0.9)} inset`,
            MozTextFillColor: '#64AE37',
          },
        },
        notchedOutline: {
          borderColor: '#64AE37',   // borde primario
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#64AE37',
          '&.Mui-focused': {
            color: '#64AE37',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial',
  },
});

export default theme;


